import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import PageMetatags from '../../layout/PageMetatags';
import AccountDetailsOverviewCard from './AccountDetailsOverviewCard';

const AccountDetailsOverviewPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { account_id, type, fastlane } = useParams();
  const fastlaneNumber = Number(fastlane);
  const accountId = Number(account_id);
  if (isNaN(accountId)) {
    navigate('/404', { replace: true });
    return null;
  }

  return (
    <>
      <PageMetatags title={t('pages:account.meta.title')} />
      <AccountDetailsOverviewCard account_id={accountId} type={type} fastlane={fastlaneNumber} />
    </>
  );
};

export default AccountDetailsOverviewPage;
